import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star } from 'lucide-react';
import { TiltPortrait } from './TiltPortrait';
import { scrollToId } from './constants';

const rise = (d) => ({
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.9, delay: d, ease: [0.2, 0.8, 0.2, 1] },
});

const Badge = () => (
  <>
    <div className="flex gap-0.5 text-[var(--br-amber)]">{[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-current" />)}</div>
    <p className="mt-2 text-sm font-semibold leading-snug">Escolhido por hotéis, veículos de imprensa e marcas líderes da região.</p>
  </>
);

export const BrandHero = () => (
  <section className="relative min-h-screen overflow-hidden br-grain pt-32 pb-20 lg:pt-36" data-testid="brand-hero">
    <div className="absolute -top-40 right-[-10%] h-[620px] w-[620px] rounded-full bg-[#4ECDC4]/10 blur-[140px]" />
    <div className="absolute bottom-[-20%] left-[-10%] h-[520px] w-[520px] rounded-full bg-[#6B1D2F]/25 blur-[140px]" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-[1.15fr_0.85fr] gap-14 lg:gap-20 items-center">
      <div>
        <motion.p {...rise(0.1)} className="br-mono text-[11px] text-[var(--br-teal)]" data-testid="hero-overline">◆ Estrategista de Marca · Foz do Iguaçu</motion.p>
        <motion.h1 {...rise(0.2)} className="mt-6 text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-semibold leading-[1.04]" data-testid="hero-title">
          Marcas fortes não disputam <em className="text-[var(--br-teal)] not-italic br-serif italic">preço.</em> Elas são escolhidas.
        </motion.h1>
        <motion.p {...rise(0.35)} className="mt-7 text-base sm:text-lg text-[var(--br-muted)] max-w-xl leading-relaxed">
          Sou Anderson Coutinho. Eu cuido de como a sua empresa é vista, para que o cliente certo escolha você antes mesmo de perguntar quanto custa.
        </motion.p>
        <motion.div {...rise(0.5)} className="mt-10 flex flex-col sm:flex-row gap-4">
          <button onClick={() => scrollToId('raio-x')} data-testid="hero-raio-x-cta" className="group inline-flex items-center justify-center gap-3 rounded-full bg-[var(--br-teal)] text-black font-bold px-8 py-4 shadow-[0_20px_60px_-15px_rgba(78,205,196,0.6)] transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-white">
            Quero meu Raio-X da Marca grátis
            <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
          </button>
          <button onClick={() => scrollToId('metodo')} data-testid="hero-method-cta" className="inline-flex items-center justify-center rounded-full border border-white/15 px-8 py-4 font-semibold text-white/90 transition-colors hover:border-[var(--br-teal)] hover:text-[var(--br-teal)]">
            Como eu trabalho
          </button>
        </motion.div>
        <motion.p {...rise(0.6)} className="mt-6 text-sm text-[var(--br-muted)]">Análise pessoal do seu perfil · resposta em até 24h · sem compromisso</motion.p>
      </div>
      <motion.div {...rise(0.3)} className="max-w-md w-full mx-auto lg:mx-0">
        <TiltPortrait src="/images/anderson-camera.jpg" alt="Anderson Coutinho, estrategista de marca" badge={<Badge />} testId="hero-portrait" />
      </motion.div>
    </div>
  </section>
);
